import React  from 'react';
import { Layout ,Typography , Table} from 'antd';

const { Header } = Layout;
const { Title , Text } = Typography;


const columns = [
  {
    title: 'City',
    dataIndex: 'name',
  },
  {
    title:'Latitude',
    dataIndex:'latitude',
  },
  {
    title:'Longitude',
    dataIndex:'longitude',
  }
];


export const LocationTable = props => {

  const { dataSource , updateformData , selectedData , loading}={...props};

  return (
      <div>
            <Table dataSource={dataSource==undefined?[]:dataSource}
                    pagination={{ pageSize: 5 }}
                   columns={columns}
                   rowClassName={ (record, index) => {return record.id== selectedData.id?"TableRowClicked":""}   }
                   loading={loading}
                   rowKey={record => record.id}
                   onRow={(record, rowIndex) => {
                      return {
                        onClick: event => {
                          updateformData(record);
                        }, // click row
                        onDoubleClick: event => {

                        }, // double click row
                        onContextMenu: event => {

                        }, // right button click row
                        onMouseEnter: event => {

                        }, // mouse enter row
                        onMouseLeave: event => {

                        }, // mouse leave row
                      };
                    }}
                   />
      </div>
  );
};